import styled from "styled-components";
import {Teal, DarkSlate} from "../../../theme/variable";
import {media} from "../../../theme/responsive.js";

export const ImageUploadInnerSection = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0px;
`;

export const ImageUploadSection = styled.div`
    width: 100%;
    height: 375px;
    display: inline-block;
    position: relative;
    overflow: hidden;
    margin-top: 0px;
`;

export const PhotoUploadSection = styled.div`
    color: ${Teal};
    font-size: 0.9375rem;
    margin: ${(props) => (props.consentFormStyle ? "0" : "6px 0")};
    input[type="file"] {
        width: 0.1px;
        height: 0.1px;
        opacity: 0;
        overflow: hidden;
        position: absolute;
        z-index: -1;
    }
    label {
        cursor: pointer;
    }
`;
export const ImageUploadBottomSection = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 16px 34px;
    justify-content: space-between;
    align-items: center;
    && label,
    button {
        height: 42px;
        line-height: 40px;
        width: 142px;
        font-size: 1.0625rem;
    }
    button {
        margin-left: 8px;
    }
    ${media.laptop` flex-direction: row;padding: 0 16px;`};
`;
export const RangeInputLabelText = styled.span`
    width: 160px;
    font-size: 0.875rem;
    line-height: 21px;
    font-weight: 600;
    text-align: center;
    ${media.laptop` text-align:left;`};
`;
export const RangeWrapper = styled.div`
    width: 100%;
    && span {
        font-size: 0.75rem;
        margin-top: 4px;
    }
    ${media.laptop` position:relative; top:9px; width:60%;`};
`;
export const UploadImageButtonArea = styled.div`
    width: 100%;
    display: inline-flex;
    justify-content: center;
    ${media.laptop`width:40%;`};
`;
export const UserImageMesageDiv = styled.div`
    padding: 6px 16px 16px;
    text-align: center;
    display: inline-block;
    border-radius: 2px;
    width: 100%;
    background-color: #ffffff;
    div {
        display: inline-block;
        width: 142px;
        > label {
            height: 42px;
            line-height: 40px;
            width: 100%;
            padding: 0 10px;
        }
    }
    p {
        font-size: 0.9375rem;
        line-height: 24px;
        margin-bottom: 5px;
    }
    button {
        margin-top: 8px;
        height: 42px;
        line-height: 40px;
        font-size: 1.0625rem;
        &:nth-child(3) {
            margin-left: 10px;
        }
    }
    ${media.laptop`padding: ${(props) => (props.discardPopupPadding ? "30px 16px" : "16px")}`};
`;
export const UserCancelLink = styled.span`
    color: ${DarkSlate};
    font-size: 1.0625rem;
    cursor: pointer;
    margin-right: 20px;
`;
